import React from 'react';
import Layout from '../../scaffolding/Layout';

const Courses = () => {
  return <Layout>Courses</Layout>;
};

export default Courses;
